export default {
  SET_UNMAPPED_CAMPAIGNS (state, campaigns) {
    state.unmappedCampaigns = campaigns
  }
}
